import { useTranslation } from 'react-i18next';
import { 
  getMarketplaceImage, 
  getUseCaseImage, 
  getWhyWeIcon, 
  getWhyWeImage
} from '../App.config';
import { Item as FlatGalleryItem } from '../components/FlatGallery/FlatGallery';
import { Item as GridGalleryItem } from '../components/GridGallery/GridGallery';
import { Pricing } from '../ui/PriceCard/PriceCard';

/**
 * Custom hook to get translated data for the application
 * This properly follows React hooks rules by being a custom hook
 */
export const useTranslatedData = () => {
  const { t, i18n } = useTranslation();
  
  try {
    // Marketplace items
    const marketPlace: FlatGalleryItem[] = t('marketplace', { returnObjects: true }).map((item: any) => ({
      ...item,
      imgSrc: getMarketplaceImage(item.key),
    }));
    
    // Pricing items
    const pricing: Pricing[] = t('pricing', { returnObjects: true });
    
    // Use cases
    const useCases: FlatGalleryItem[] = t('useCases', { returnObjects: true }).map((item: any) => ({
      ...item,
      imgSrc: getUseCaseImage(item.key),
    }));
    
    // Why we
    const whyWe: GridGalleryItem[] = t('whyWe', { returnObjects: true }).map((item: any) => ({
      ...item,
      icon: getWhyWeIcon(item.key),
      imgSrc: getWhyWeImage(item.key), // Now returns an object with src, width, and height
      isBig: item.key === 'brand',
    }));
    
    return {
      marketPlace,
      pricing,
      useCases,
      whyWe,
      currentLanguage: i18n.language
    };
  } catch (error) {
    console.error('Error loading translations, using defaults:', error);
    
    // Create empty fallback data with proper structure
    const emptyMarketPlace: FlatGalleryItem[] = [];
    const emptyPricing: Pricing[] = [];
    const emptyUseCases: FlatGalleryItem[] = [];
    const emptyWhyWe: GridGalleryItem[] = [];
    
    return {
      marketPlace: emptyMarketPlace,
      pricing: emptyPricing,
      useCases: emptyUseCases,
      whyWe: emptyWhyWe,
      currentLanguage: i18n.language
    };
  }
};

export default useTranslatedData;